type TokenGetter = () => Promise<string | null>
type AuthFailureHandler = () => Promise<void>

let clerkTokenGetter: TokenGetter | null = null
let clerkAuthFailureHandler: AuthFailureHandler | null = null
let authFailurePromise: Promise<void> | null = null
let authEpoch = 0
export const getAuthEpoch = () => authEpoch
export function advanceAuthEpoch() {
  authEpoch += 1
}

export function setTokenGetter(getter: TokenGetter): void {
  clerkTokenGetter = getter
}

export function setAuthFailureHandler(handler: AuthFailureHandler): void {
  clerkAuthFailureHandler = handler
}

export function resetTokenBridge(): void {
  clerkTokenGetter = null
  clerkAuthFailureHandler = null
  authFailurePromise = null
}

export async function getAuthToken(): Promise<string | null> {
  if (clerkTokenGetter) {
    return clerkTokenGetter()
  }

  return null
}

export async function handleAuthFailure(): Promise<void> {
  if (!clerkAuthFailureHandler) {
    return
  }

  if (!authFailurePromise) {
    authFailurePromise = clerkAuthFailureHandler().finally(() => {
      authFailurePromise = null
    })
  }

  return authFailurePromise
}
